import React from "react";
import Footer from "../../Components/Footer";
import Header from "../../Components/Header";
import "./CreateCollection.scss";
import Api from "../../Common/api.jsx";
import Cropper from "react-cropper";
import "cropperjs/dist/cropper.css";
import { Navigate, Redirect } from "react-router-dom";
import MetaMaskService from "../../Common/metamaskService.jsx";
import { notifications } from "../../Helpers/Notifications";
import { ToastContainer } from "react-toastify";
import { useState, useEffect } from "react";

const initialState = {
  inputtype: "file",
  createCollectionArray: [],
  redirect: null,
  image: null,
  cropData: "#",
  cropper: null,
  preview: false,

  bannerImage: null,
  bannerCropData: "#",
  bannerCropper: null,
  bannerPreview: false,

  collection_name: "",
  user_id: 14,
  collection_description: "",
  website: "",
  discord: null,
  instagram: null,
  telegram: null,
  medium: null,
  collection_image: "",
  banner_image: "",

  categories: null,
  user: null,
  category_id: "",

  isSaving: false,
  openPopup: false,

  isError: {
    collection_name: null,
    website: "",
    categories: "",
    cImageName: "",
    banner: "",
    collection_description: "",
  },
};
export default class CreateCollection extends React.Component {
  constructor(props) {
    super(props);
    this.cName = "";
    this.websitename = "";
    this.descriptionName = "";
    this.categoryName = "";
    this.cImageName = "";
    this.bannerImageName = "";
    //this.formValid;
    this.state = initialState;
  }
  reset() {
    this.setState(initialState);
  }

  handleClick() {
    this.refs["bImage"].click();
    //inputRef.current.click();
  }
  handlePImage() {
    this.refs["pImage"].click();
    //inputRef.current.click();
  }
  async componentDidMount() {
    window.addEventListener("click", () => {
      document.getElementsByClassName("search-autocomplete")[0].style.display =
        "none";
    });
    this.getPredefineCategory();
    this.getAccount().then((account) => {
      this.getUserDetails(account);
    });
  }

  onChangeFun(e, forImage) {
    let t = this;
    e.preventDefault();
    let files;
    if (e.dataTransfer) {
      files = e.dataTransfer.files;
    } else if (e.target) {
      files = e.target.files;
    }
    const reader = new FileReader();
    reader.onload = () => {
      if (forImage == "collection") {
        this.setState({ image: reader.result });
        this.setState({ preview: true });
      } else {
        this.setState({ bannerImage: reader.result });
        this.setState({ bannerPreview: true });
      }
    };
    reader.readAsDataURL(files[0]);
    if (forImage == "collection") {
      //this.clearCropdata("collection");
      this.setState({ preview: false, cropData: "#", image: null });
    } else {
      //this.clearCropdata("bannerImage");
      this.setState({
        bannerPreview: false,
        bannerCropData: "#",
        bannerImage: null,
      });
    }
  }

  formValid({ isError, ...rest }) {
    let isValid = false;
    if (
      this.cName == "" ||
      //this.websitename == "" ||
      this.descriptionName == "" ||
      this.categoryName == "" ||
      this.cImageName == "" ||
      this.bannerImageName == ""
    ) {
      isValid = true;
    }
    if (
      this.state.collection_name == "" ||
      //this.state.website == "" ||
      this.state.collection_description == "" ||
      this.state.category_id == "" ||
      this.state.cropData == "" ||
      this.state.cropData == "#" ||
      this.state.bannerCropData == "" ||
      this.state.bannerCropData == "#"
    ) {
      isValid = false;
    }
    return isValid;
    /*Object.values(isError).forEach(val => {
        if (val.length > 0) {
            isValid = true
        } else {
            isValid = false
        }
    });
    Object.values(rest).forEach(val => {
        if (val === null) {
            isValid = false
        } else {
            isValid = true
        }
    });*/
    return isValid;
  }
  onSubmit = (e) => {
    this.formValChange({
      target: { name: "collection_name", value: this.state.collection_name },
    });
    this.formValChange({
      target: {
        name: "collection",
        value: this.state.cropData.length > 2 ? "1" : "0",
      },
    });
    // this.formValChange({
    //   target: { name: "website", value: this.state.website },
    // });
    this.formValChange({
      target: {
        name: "collection_description",
        value: this.state.collection_description,
      },
    });
    this.formValChange({
      target: { name: "category", value: this.state.category_id },
    });
    this.formValChange({
      target: {
        name: "banner",
        value: this.state.bannerCropData.length > 2 ? "1" : "0",
      },
    });
    //console.log(this.formValid(this.state));
    if (this.formValid(this.state)) {
      this.createCollectionFun();
      this.state.inputtype = "text";
      this.state.inputtype = "file";
    } else {
      console.log("Form is invalid!");
      //this.createCollectionFun()
      //this.formValChange(e)
    }
  };

  formValChange(e) {
    // e.preventDefault();
    const { name, value } = e.target;
    console.log(name, value);
    let isError = { ...this.state.isError };
    switch (name) {
      case "collection_name":
        this.cName = value.length == 0 ? "collection name is required" : "";
        //this.state.isError.collection_name = value.length == 0 ? "collection name is required" : "";
        break;
      //case "website":
        //this.websitename = value.length == 0 ? "Url is required" : "";
        //this.state.isError.website  == 0 ? "Url is required" : ""
      //  break;
      case "collection_description":
        this.descriptionName =
          value.length == 0 ? "Description is required" : "";
        //this.state.isError.collection_description = value.length > 0 ? "Description is required" : "";
        break;
      case "category":
        this.categoryName = value == 0 ? "Category is required" : "";
        //this.state.isError.categories =value.length > 0 ? "Category is required" : "";
        break;
      case "collection":
        this.cImageName = value == 0 ? "image is required" : "";
        //this.state.isError.cImageName =value == 0 ? "image is required" : "";
        break;
      case "banner":
        this.bannerImageName = value == 0 ? "Banner image is required" : "";
        //this.state.isError.bannerImageName =value == 0 ? "Banner image is required" : "";
        break;
      default:
        break;
    }
    this.setState({
      isError,
      [name]: value,
    });
    console.log(this.state.isError);
  }

  getCropData(forImage) {
    if (typeof this.state.cropper !== "undefined" && forImage == "collection") {
      this.setState({
        cropData: this.state.cropper.getCroppedCanvas().toDataURL(),
      });
      // this.onCropperInit(null, "collection");
      console.log(this.state);
    } else if (
      typeof this.state.bannerCropper !== "undefined" &&
      forImage == "bannerImage"
    ) {
      this.setState({
        bannerCropData: this.state.bannerCropper.getCroppedCanvas().toDataURL(),
      });
      // this.onCropperInit(null, "bannerImage");
    }
  }

  async getPredefineCategory() {
    const api = new Api();
    var parameter = "";
    api
      .get("get_categories/", parameter)
      .then((response) => {
        //console.log("categories", response.data);
        this.setState({ categories: response.data });
      })
      .catch((err) => console.log(err));
  }

  async getAccount() {
    var account = await new MetaMaskService().getAccount();
    console.log(account);
    return account;
  }

  async getUserDetails(account) {
    const api = new Api();

    api
      .get("get_user_details/?account=" + account)
      .then((response) => {
        this.setState({ user: response.data[0] });
      })
      .catch((err) => console.log(err));
  }

  onCropperInit(instance, forImage) {
    console.log(instance);
    if (forImage == "collection") {
      this.setState({ cropper: instance });
      console.log(this.state.cropper);
    } else {
      this.setState({ bannerCropper: instance });
    }
  }

  clearCropdata(forImage) {
    if (forImage == "collection") {
      this.setState({ preview: false });
      this.setState({ cropData: "#" });
      this.setState({ image: null });
    } else {
      this.setState({ bannerPreview: false });
      this.setState({ bannerCropData: "#" });
      this.setState({ bannerImage: null });
    }
  }

  handleChange(e) {
    console.log(e, e.target.name);
    this.setState({ [e.target.name]: e.target.value });
    this.formValChange(e);
    console.log(this.state);
  }

  createCollectionFun() {
    const api = new Api();
    this.setState({ isSaving: true });
    const obj = {
      collection_name: this.state.collection_name,
      user_id: this.state.user.id,
      collection_description: this.state.collection_description,
      website: this.state.website,
      discord: this.state.discord,
      instagram: this.state.instagram,
      telegram: this.state.telegram,
      medium: this.state.medium,
      collection_image: this.state.cropData,
      banner_image: this.state.bannerCropData,
      category_id: parseInt(this.state.category_id),
    };
    const requestOptions = {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: obj,
    };
    api
      .post("create_collection/", obj)
      .then((response) => {
        console.log(response);
        this.setState({ createCollectionArray: response.data });
        this.setState({ openPopup: true, isSaving: false });

        if (response.data.id) {
          notifications.success("Collection created successfully");

          const timer = setTimeout(() => {
            this.setState({ redirect: "../MyCollections" });
          }, 1000);
        } else {
          notifications.error("Something went wrong.");
          this.setState({ openPopup: true, isSaving: false });
        }
      })
      .catch((err) => {
        console.log(err);
        notifications.error("Something went wrong.");
        this.setState({ openPopup: true, isSaving: false });
      });
  }

  render = () => {
    if (this.state.redirect) {
      return <Navigate to={this.state.redirect} />;
    }
    const { isError } = this.state;
    return (
      <>
        <ToastContainer pauseOnFocusLoss draggable pauseOnHover />
        <Header />
        <section className="edit-profile">
          <div className="container">
            <div className="edit-profile__form-wrapper">
              <div className="section-title">
                <h2>CREATE A COLLECTION</h2>
              </div>
              <div className="edit-profile__img">
                <span className="spanImage_Profile">Logo Image</span>
                <span className="spanRecommended-Profile">
                  350 x 350 px recommended
                </span>
                <div
                  style={{
                    display: this.state.preview == false ? "block" : "none",
                  }}
                  className="edit-profile__img-upload"
                >
                  <i className="material-icons-outlined">upload_file</i>
                  <input
                    type={this.state.inputtype}
                    accept="image/*"
                    id="contained-button-file"
                    onChange={(e) => {
                      this.onChangeFun(e, "collection");
                    }}
                  />
                </div>
                {/* <div className="edit-profile__img-uploaded" style={{ display: this.state.preview == true && this.state.cropData != "#" ? "block" : "none", }}>
                 
                </div>  */}
                <div
                  style={{
                    display:
                      this.state.preview == true && this.state.cropData != "#"
                        ? "block"
                        : "none",
                  }}
                  className="edit-profile__img-uploaded-collection"
                >
                  <img
                    onClick={(e) => this.handlePImage(e)}
                    src={this.state.cropData}
                  />
                  <button className="btn-edit-profile">
                    <label htmlFor="contained-button-file">
                      <img src="../images/svg/edit.svg" alt="" />
                    </label>
                  </button>
                </div>
                <Cropper
                  style={{
                    height: 400,
                    width: "100%",
                    display:
                      this.state.cropData == "#" && this.state.preview == true
                        ? "block"
                        : "none",
                  }}
                  zoomTo={0.5}
                  zoomable={false}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={this.state.image}
                  viewMode={1}
                  cropBoxResizable={false}
                  minCropBoxHeight={5}
                  minCropBoxWidth={10}
                  background={false}
                  responsive={true}
                  autoCropArea={1}
                  checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                  onInitialized={(instance) => {
                    this.onCropperInit(instance, "collection");
                  }}
                  guides={true}
                />

                <h1
                  style={{
                    marginTop: 20 + "px",
                    marginRight: 89 + "px",
                    display: this.state.image ? "block" : "none",
                  }}
                >
                  {this.state.preview && this.state.cropData == "#" ? (
                    <a
                      className="button"
                      onClick={() => [
                        this.getCropData("collection"),
                        this.formValChange({
                          target: { name: "collection", value: "1" },
                        }),
                      ]}
                    >
                      Crop Image
                    </a>
                  ) : (
                    ""
                  )}

                  {this.state.preview && this.state.cropData == "#" ? (
                    <a
                      className="button"
                      onClick={() => this.clearCropdata("collection")}
                    >
                      Reset
                    </a>
                  ) : (
                    ""
                  )}
                </h1>
                <p className="error"> {this.cImageName} </p>

                {/* <span className="spanImage">Featured Image</span>
            <span className="spanRecommended">600 x 400 px recommended</span>
              <div style={{display: this.state.preview ==false ? 'block' : 'none'}}  className="edit-profile__img-upload" id="secondCropImg">
                <i className="material-icons-outlined">upload_file</i>
                <input type="file" onChange={(e) => {this.onChangeFun(e,'collection')}}/>
              </div>
              <div style={{display: this.state.preview ==true? 'block' : 'none'}} className="edit-profile__img-upload" id="secondCropImg">
                <img style={{width:500+'px'}} src={this.state.cropData} />
              </div> */}

                <span className="spanImage_Banner">Banner Image</span>
                <span className="spanRecommended-banner">
                  1400x350 px recommended
                </span>
                <div
                  style={{
                    display:
                      this.state.bannerPreview == false ? "block" : "none",
                  }}
                  className="edit-banner__img-upload"
                >
                  <i className="material-icons-outlined">upload_file</i>
                  <input
                    //ref="bImage"
                    id="contained-button-file-banner"
                    type={this.state.inputtype}
                    accept="image/*"
                    onChange={(e) => {
                      this.onChangeFun(e, "bannerImage");
                    }}
                  />
                </div>
                {/* <button className="btn-edit-profile" style={{ display: this.state.bannerPreview == true && this.state.bannerCropData != "#" ? "block" : "none", }}>
                  <label htmlFor="contained-button-file-banner">
                    <img src="../images/svg/edit.svg" alt="" />
                  </label>
                </button> */}
                <div
                  style={{
                    display:
                      this.state.bannerPreview == true &&
                      this.state.bannerCropData != "#"
                        ? "block"
                        : "none",
                  }}
                  className="edit-banner__img-uploaded"
                >
                  <img
                    onClick={(e) => this.handleClick()}
                    src={this.state.bannerCropData}
                  />
                  <button className="btn-edit-profile">
                    <label htmlFor="contained-button-file-banner">
                      <img src="../images/svg/edit.svg" alt="" />
                    </label>
                  </button>
                </div>

                <Cropper
                  style={{
                    height: 400,
                    width: "100%", //"400px",
                    display:
                      this.state.bannerCropData == "#" &&
                      this.state.bannerPreview == true
                        ? "block"
                        : "none",
                  }}
                  zoomTo={0.5}
                  zoomable={false}
                  initialAspectRatio={1}
                  preview=".img-preview"
                  src={this.state.bannerImage}
                  viewMode={1}
                  cropBoxResizable={false}
                  minCropBoxHeight={350}
                  minCropBoxWidth={1400}
                  background={false}
                  responsive={true}
                  autoCropArea={1}
                  checkOrientation={false} // https://github.com/fengyuanchen/cropperjs/issues/671
                  onInitialized={(instance) => {
                    this.onCropperInit(instance, "bannerImage");
                  }}
                  guides={true}
                />
                <h1
                  style={{
                    marginTop: 20 + "px",
                    marginRight: 89 + "px",
                    display: this.state.bannerImage ? "block" : "none",
                  }}
                >
                  <a
                    style={{
                      display:
                        this.state.bannerPreview == true &&
                        this.state.bannerCropData != "#"
                          ? "none"
                          : "inline-flex",
                    }}
                    className="button"
                    onClick={() => [
                      this.getCropData("bannerImage"),
                      this.formValChange({
                        target: { name: "banner", value: "1" },
                      }),
                    ]}
                  >
                    Crop Image
                  </a>
                  &nbsp;&nbsp;&nbsp;
                  <a
                    style={{
                      display:
                        this.state.bannerPreview == true &&
                        this.state.bannerCropData != "#"
                          ? "none"
                          : "inline-flex",
                    }}
                    className="button"
                    onClick={() => this.clearCropdata("bannerImage")} //, this.formValChange({target:{name:'banner',value:'0'}})]}
                  >
                    Reset
                  </a>
                </h1>
                <p className="error">{this.bannerImageName}</p>
              </div>

              <div className="edit-profile__form">
                <div className="form-group">
                  <label>
                    Collection Name <span className="asterisk">*</span>
                  </label>
                  <input
                    type="text"
                    className="form-control" //{this.cName !=="" ? "borderRed form-control" : "form-control"}
                    placeholder="Enter the name of your item"
                    name="collection_name"
                    value={this.state.collection_name}
                    readOnly={this.state.isSaving}
                    onChange={(e) => {
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <p className="error">{this.cName}</p>
                </div>
                <div className="form-group">
                  <label>
                    URL 
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.yoursite.io/item/123"
                    name="website"
                    value={this.state.website}
                    readOnly={this.state.isSaving}
                    onChange={(e) => {
                      //this.setState({website: e.target.value})
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <p className="error">{this.websitename}</p>
                </div>
                <div className="form-group">
                  <label>
                    Description <span className="asterisk">*</span>
                  </label>
                  <div className="form-control__wrapp">
                    <textarea
                      className="form-control textarea"
                      name="collection_description"
                      value={this.state.collection_description}
                      readOnly={this.state.isSaving}
                      onChange={(e) => {
                        //this.setState({collection_description: e.target.value})
                        this.handleChange({
                          target: {
                            name: e.target.name,
                            value: e.target.value,
                          },
                        });
                      }}
                      placeholder="Enter a detailed description about yourself"
                    ></textarea>
                    <p className="error">{this.descriptionName}</p>
                  </div>
                </div>
                <div className="form-group">
                  <label>
                    Category <span className="asterisk">*</span>
                  </label>
                  <div className="form-control select-dd">
                    <select
                      style={{ background: "rgb(31 36 56)" }}
                      name="category"
                      disabled={this.state.isSaving}
                      value={this.state.category_id}
                      onChange={(e) => [
                        this.setState({ category_id: e.target.value || null }),
                        this.formValChange(e),
                      ]}
                    >
                      <option value="0">Select Category</option>
                      {this.state.categories?.map((e, key) => {
                        return (
                          <option key={key} value={e.id}>
                            {e.name}
                          </option>
                        );
                      })}
                    </select>
                  </div>
                  <p className="error">{this.categoryName}</p>
                </div>

                {/* <div className="form-group">
                <label>Category <span className="asterisk">*</span></label>
                <div className="form-control select-dd">
                  <select>
                      <option value="item1">Select Collection</option>
                      <option value="item2">Collection 1</option>
                      <option value="item3">Collection 2</option>
                      <option value="item4">Collection 3</option>
                  </select>
                </div> 
              </div> */}
                <div className="form-group">
                  <label>Links</label>
                  <img
                    className="discordIcon"
                    src="../images/Discord.png"
                    alt="Coin"
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.discord.gg/example"
                    name="discord"
                    value={this.state.discord}
                    readOnly={this.state.isSaving}
                    onChange={(e) => {
                      //this.setState({discord: e.target.value})
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <img
                    className="instaIcon"
                    src="../images/Instagramlogo.png"
                    alt="Coin"
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.instagram.com/example"
                    name="instagram"
                    value={this.state.instagram}
                    readOnly={this.state.isSaving}
                    onChange={(e) => {
                      //this.setState({instagram: e.target.value})
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <img
                    className="telegramIcon"
                    src="../images/Telegramlogo.png"
                    alt="Coin"
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.t.me/example"
                    name="telegram"
                    value={this.state.telegram}
                    readOnly={this.state.isSaving}
                    onChange={(e) => {
                      //this.setState({telegram: e.target.value})
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                  <img
                    className="mediumIcon"
                    src="../images/Mediumlogo.png"
                    alt="Coin"
                  />
                  <input
                    type="text"
                    className="form-control"
                    placeholder="https://www.medium.com/@example"
                    name="medium"
                    value={this.state.medium}
                    readOnly={this.state.isSaving}
                    onChange={(e) => {
                      // this.setState({medium: e.target.value})
                      this.handleChange({
                        target: {
                          name: e.target.name,
                          value: e.target.value,
                        },
                      });
                    }}
                  />
                </div>
                {/* <div className="form-group">
                <label>Creator Earnings (percentage) <span className="asterisk">*</span></label>
                <input type="text" className="form-control"
                 placeholder="e.g : 2.5%"
                 name="testcharsau220721175829.wav"
                /> 
              </div>
              <div className="form-group">
                <label>Tags (Separated by commas) </label>
                <input type="text" className="form-control"
                 placeholder="e.g : art, painting,etc"
                 name="testcharsau220721175829.wav"
                /> 
              </div> */}
                {this.state.isSaving ? (
                  <div className="form-group__btn">
                    <div className="button btn-waiting ">
                      <img
                        className="loader"
                        src="../Loader/redshilliz-loader.gif "
                        alt="Coin"
                      />
                      Creating...
                    </div>
                  </div>
                ) : (
                  <div className="form-group__btn">
                    <a
                      className="button"
                      //onClick={() => this.createCollectionFun()}
                      onClick={(e) => this.onSubmit()}
                    >
                      Create Collection
                    </a>
                    {/* <a  className="btn-text">  <i className="material-icons-outlined">visibility</i> Preview</a> */}
                  </div>
                )}
              </div>
            </div>
          </div>
        </section>
        <Footer />
      </>
    );
  };
}
